import { useAppContext } from '@hooks/use-app-context.ts'
import { useModal } from '@hooks/use-modal.ts'
import { analyticsCurrentAction } from '@store/atoms'
import { Actions } from '@store/reducer.ts'
import { useSetAtom } from 'jotai'

export function useThankyouModal(/*areDocsAvailable: boolean*/) {
	const { dispatch } = useAppContext()
	const { open } = useModal()
	const setAnalyticsAction = useSetAtom(analyticsCurrentAction)

	const startLocalModal = () => {
		setAnalyticsAction('TnkYou_AllegaDocumenti')
		dispatch({
			type: Actions.ShowModal,
			payload: 'Thanks_DOCS',
		})

		open()
	}

	const startPollingModal = () => {
		setAnalyticsAction('TnkYou_FotografaDocumenti')
		dispatch({
			type: Actions.ShowModal,
			payload: 'Richiesta_MOBILE',
		})

		open()
	}

	const startMobileModal = () => {
		setAnalyticsAction('TnkYou_FotografaDocumenti')
		dispatch({
			type: Actions.ShowModal,
			payload: 'Richiesta_CARTA-ID',
		})

		open()
	}

	return {
		actions: {
			startLocalModal,
			startPollingModal,
			startMobileModal,
		},
	}
}
